import React from 'react';

const ProgressBar = ({ currentStep, totalSteps }) => {
    const steps = [
        { number: 1, label: 'Search', description: 'Choose your favorite room' },
        { number: 2, label: 'Booking', description: 'Enter your booking details' },
        { number: 3, label: 'Checkout', description: 'Use your preferred payment method' },
        { number: 4, label: 'Confirmation', description: 'Receive a confirmation email' },
    ];

    return (
        <div className="progress-bar-container mb-4">
            <div className="d-flex justify-content-between align-items-center">
                {steps.map((step, index) => (
                    <div key={step.number} className="text-center flex-grow-1">
                        <div className={`step-circle ${currentStep === step.number ? 'bg-success text-white' : 'bg-secondary text-white'}`}>
                            {step.number}
                        </div>
                        <div className={`step-label ${currentStep === step.number ? 'text-dark fw-bold' : 'text-muted'}`}>
                            {step.label}
                        </div>
                        <small className="d-block text-muted">{step.description}</small>
                    </div>
                ))}
            </div>
            <hr className="mt-2" style={{ borderTop: '2px solid #ddd' }} />
        </div>
    );
};

export default ProgressBar;